var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 11.5858 3.33579 11.25 3.75 11.25C4.16421 11.25 4.5 11.5858 4.5 12C4.5 12.4142 4.16421 12.75 3.75 12.75C3.33579 12.75 3 12.4142 3 12ZM3.75 9.75C2.50736 9.75 1.5 10.7574 1.5 12C1.5 13.2426 2.50736 14.25 3.75 14.25C4.99264 14.25 6 13.2426 6 12C6 10.7574 4.99264 9.75 3.75 9.75ZM12 11.25C11.5858 11.25 11.25 11.5858 11.25 12C11.25 12.4142 11.5858 12.75 12 12.75C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12ZM20.25 11.25C19.8358 11.25 19.5 11.5858 19.5 12C19.5 12.4142 19.8358 12.75 20.25 12.75C20.6642 12.75 21 12.4142 21 12C21 11.5858 20.6642 11.25 20.25 11.25ZM18 12C18 10.7574 19.0074 9.75 20.25 9.75C21.4926 9.75 22.5 10.7574 22.5 12C22.5 13.2426 21.4926 14.25 20.25 14.25C19.0074 14.25 18 13.2426 18 12Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/more.d08bfe6843fc9bb7328812cc2ad213a3.svg";